import content from "app-content";
import formatPrice from "../../formatPrice";

export default ({ colour, price, isColourInStock }) =>
  `${colour}${price ? ` ${formatPrice(price.current.value)}` : ""}${
    !isColourInStock ? ` - ${content.saved_items_item_product_oos}` : ""
  }`;
